import { useState, useEffect, Fragment, useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import useFormUploadVesselOwnerLicenses from "../Libs/useVesselOnerLicenses";
import { ReactComponent as UploadIcon } from "../../Asset/upload-cloud-02.svg";
import Spinner from "../../Utils/spinner/loading";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { RiDeleteBin5Line } from "react-icons/ri";
import { CiFileOn } from "react-icons/ci";
import useFormUploadOtherDocs from "../Libs/useFormUploadOtherDocs";
import { AuthContext } from "../../Context/AuthContext";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";

const VesselOwnerLicenses = () => {
  const navigate = useNavigate();
  const { user, token } = useContext(AuthContext);
  const { handleSubmit, loading, error, success } =
    useFormUploadVesselOwnerLicenses();
  const {
    handleSkip,
  } = useFormUploadOtherDocs();

  const [formData, setFormData] = useState({
    dpr: null,
    npa: null,
  });
  const [fileDetails, setFileDetails] = useState({
    dpr: null,
    npa: null,
  });

  const [licensesSubmitted, setLicensesSubmitted] = useState(false);

  const handleNoClick = useCallback(async () => {
    if (user?.role === "charterer") {
      await handleSkip();
    } else if (user?.role === "vesselOwner") {
      try {
        const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/vesselOwner/profile/upload/otherDocuments`, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ skipped: true ,signedVesselNominationAgreement: true, }),
        });
        
        const resData = await res.json();
        if (!res.ok) throw new Error(resData.message);
        
        setTimeout(() => {
          navigate("/v_contact_person");
        }, 1000);
      } catch (error) {
        console.error("Error skipping licenses:", error.message);
      }
    }
  }, [user?.role, handleSkip, token, navigate]);

  // Auto-skip additional documents after licenses are successfully submitted
  useEffect(() => {
    if (success && !licensesSubmitted) {
      setLicensesSubmitted(true);
      // Automatically call handleNoClick to skip additional documents
      handleNoClick();
    }
  }, [success, licensesSubmitted, handleNoClick]);

  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      [fieldName]: file,
    });

    setFileDetails((prevFileDetails) => ({
      ...prevFileDetails,
      [fieldName]: {
        name: file.name,
        size: file.size,
        type: file.type,
      },
    }));
  };

  const handleFileDelete = (fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: null,
    });
    setFileDetails({
      ...fileDetails,
      [fieldName]: null,
    });
  };

  const handleFinish = (e) => {
    e.preventDefault();
    handleSubmit(e, formData);
  };

  const formatFileSize = (size) => {
    if (size >= 1000000) {
      return (size / 1000000).toFixed(2) + " MB";
    } else if (size >= 1000) {
      return (size / 1000).toFixed(2) + " KB";
    } else {
      return size + " bytes";
    }
  };

  return (
    <Fragment>

      <div className="licenses-container">
        <div className="wrap">
          <div className="header">
            <button onClick={() => navigate("/updates")}>Back</button>
            {/* <Link to="/">Vessel Owner</Link> */}
            <BlackVatugIcon onClick={() => navigate("/")} />
            <button
              className="finished"
              onClick={handleFinish}
              disabled={loading}
            >
              {loading ? <Spinner /> : "Finish"}
            </button>
          </div>
          <form>
            <h2>Licenses</h2>
            {!fileDetails.dpr && (
              <label>
                DPR
                <span>
                  <input
                    type="file"
                    hidden
                    onChange={(e) => handleFileChange(e, "dpr")}
                    accept=".pdf"
                  />
                  <>
                    <UploadIcon />
                    <p>
                      Drop pdf here, <span>or browse</span>
                    </p>
                    <h5>Supports: PDF</h5>
                  </>
                </span>
              </label>
            )}

            {fileDetails.dpr && (
              <div className="uploaded">
                <div className="wrap">
                  <CiFileOn className="file" />
                  <div className="in">
                    <span>
                      <h3>{fileDetails.dpr.name}</h3>
                    </span>
                    <p>
                      {formatFileSize(fileDetails.dpr.size)} - 100% Uploaded
                    </p>
                  </div>
                </div>
                <div className="last">
                  <IoCheckmarkDoneCircleOutline className="mark" />
                  <RiDeleteBin5Line
                    onClick={() => handleFileDelete("dpr")}
                    className="delete"
                  />
                </div>
              </div>
            )}

            {!fileDetails.npa && (
              <label>
                NPA
                <span>
                  <input
                    type="file"
                    hidden
                    onChange={(e) => handleFileChange(e, "npa")}
                    accept=".pdf"
                  />
                  <>
                    <UploadIcon />
                    <p>
                      Drop pdf here, <span>or browse</span>
                    </p>
                    <h5>Supports: PDF</h5>
                  </>
                </span>
              </label>
            )}

            {fileDetails.npa && (
              <div className="uploaded">
                <div className="wrap">
                  <CiFileOn className="file" />
                  <div className="in">
                    <span>
                      <h3>{fileDetails.npa.name}</h3>
                    </span>
                    <p>
                      {formatFileSize(fileDetails.npa.size)} - 100% Uploaded
                    </p>
                  </div>
                </div>
                <div className="last">
                  <IoCheckmarkDoneCircleOutline className="mark" />
                  <RiDeleteBin5Line
                    onClick={() => handleFileDelete("npa")}
                    className="delete"
                  />
                </div>
              </div>
            )}

            <button onClick={handleFinish} disabled={loading}>
              {" "}
              {loading ? <Spinner /> : "Finish"}
            </button>

            {error && (
              <p
                style={{
                  margin: "auto",
                  color: "red",
                  fontFamily: "Montserrat",
                }}
              >
                {error}
              </p>
            )}
            {success && (
              <p
                style={{
                  margin: "auto",
                  color: "green",
                  fontFamily: "Montserrat",
                }}
              >
                {success}
              </p>
            )}
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default VesselOwnerLicenses;
